package com.evoapps.evoshift.data.mapper

import com.evoapps.evoshift.data.dto.finance.CostDto
import com.evoapps.evoshift.domain.model.AllocationBasis
import com.evoapps.evoshift.domain.model.AllocationMethod
import com.evoapps.evoshift.domain.model.CostAllocation
import com.evoapps.evoshift.domain.model.FixedCost

class CostMapper(
    private val costSourceTypeMapper: CostSourceTypeMapper
) {

    fun toDomain(dto: CostDto): FixedCost {
        return FixedCost(
            id = dto.id,
            name = dto.name,
            amount = dto.amount,
            currency = dto.currency,
            date = dto.date,
            sourceType = costSourceTypeMapper.toDomain(dto.sourceType),
            note = dto.note,
            originRuleId = dto.originRuleId,
            kind = com.evoapps.evoshift.domain.model.LedgerKind.fromId(dto.kind),
            allocation = allocationOf(dto),
            endDate = dto.endDate?.takeIf { it > dto.date },
            frequency = com.evoapps.evoshift.domain.model.CostFrequency.entries.firstOrNull { it.name == dto.frequency }
        )
    }

    fun toDto(domain: FixedCost): CostDto {
        return CostDto(
            id = domain.id,
            name = domain.name,
            amount = domain.amount,
            currency = domain.currency,
            date = domain.date,
            sourceType = costSourceTypeMapper.toDto(domain.sourceType),
            originRuleId = domain.originRuleId,
            note = domain.note,
            kind = domain.kind.name,
            originSharedCostId = domain.allocation?.sharedCostId,
            allocationMethod = domain.allocation?.method?.name,
            allocationBasis = domain.allocation?.basis?.name,
            allocationShare = domain.allocation?.sharePercent,
            sharedTotal = domain.allocation?.total,
            endDate = domain.endDate?.takeIf { it > domain.date },
            frequency = domain.frequency?.name
        )
    }

    /** SH-131: where a part of a shared cost came from; null for every other cost. */
    private fun allocationOf(dto: CostDto): CostAllocation? {
        val origin = dto.originSharedCostId ?: return null
        return CostAllocation(
            sharedCostId = origin,
            method = AllocationMethod.entries.firstOrNull { it.name == dto.allocationMethod } ?: AllocationMethod.PROPORTIONAL,
            basis = AllocationBasis.entries.firstOrNull { it.name == dto.allocationBasis },
            sharePercent = dto.allocationShare ?: 0.0,
            total = dto.sharedTotal ?: dto.amount
        )
    }
}
